/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useLocation } from "react-router-dom";
import { debounce } from "@material-ui/core";

const RememberScroll = () => {
  const location = useLocation();

  const [scrollPositions, setScrollPositions] = React.useState({});
  const prevPath = React.useRef(null);

  React.useEffect(() => {
    //Check if we just need to scroll to the hash
    if (prevPath.current === location.pathname) {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }

      return;
    }

    if (scrollPositions[location.pathname]) {
      if (location.hash) {
        setTimeout(() => {
          const element = document.querySelector(location.hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 700);
      }
      else {
        setTimeout(() => {
          window.scrollTo(0, scrollPositions[location.pathname]);
        }, 700);
      }
    }
    else {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 700);
    }

    const handleScroll = debounce(() => {
      setScrollPositions((prev) => ({
        ...prev,
        [location.pathname]: window.scrollY,
      }));
    }, 100);

    window.addEventListener("scroll", handleScroll);
    prevPath.current = location.pathname;

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname, location.hash]);

  return null;
};

export default RememberScroll;
